(function(){
  function ready(fn){
    if(document.readyState === "loading") document.addEventListener("DOMContentLoaded", fn);
    else fn();
  }

  ready(function(){
    const root = document.getElementById("zq-quiz");
    if(!root) return;

    const ANIMALS = [
      "Perro","Gato","Caballo","Búho","Toro","Zorro","Rinoceronte","Elefante","Jirafa",
      "Jaguar","Venado","Tiburón","Pingüino","Conejo","León","Gallo","Oso"
    ];

    // ✅ COPY B2C (tu texto)
    const COPY = {
      "Perro":"Lealtad y corazón. Eres alguien que cuida, acompaña y construye vínculos reales.",
      "Gato":"Independencia y misterio. Observas el mundo a tu ritmo. Tu energía es tranquila y elegante.",
      "Caballo":"Libertad. Te mueve la aventura, el crecimiento y los nuevos caminos.",
      "Búho":"Intuición profunda. Prefieres observar antes de actuar. Ves lo que otros no ven.",
      "Toro":"Determinación. Cuando decides algo, vas con todo. Tu fuerza está en la constancia.",
      "Zorro":"Creatividad inteligente. Ingeniosa, curiosa y estratégica. Siempre encuentras soluciones.",
      "Rinoceronte":"Fortaleza interior. Silenciosa pero poderosa. No te detienes fácilmente.",
      "Elefante":"Sensibilidad y memoria. Conectas profundamente con las emociones y los recuerdos.",
      "Jirafa":"Perspectiva. Ves el panorama completo. Inspiras calma y claridad.",
      "Jaguar":"Intensidad. Energía fuerte, mirada firme y presencia única.",
      "Venado":"Elegancia natural. Sensibilidad, belleza y conexión con lo sutil.",
      "Tiburón":"Determinación valiente. Te mueves hacia adelante sin miedo a lo desconocido.",
      "Pingüino":"Amor y comunidad. Disfrutas construir juntos y crear momentos compartidos.",
      "Conejo":"Alegría y creatividad. Tu energía es ligera, curiosa y llena de ideas.",
      "León":"Confianza. Lideras desde la seguridad en quién eres.",
      "Gallo":"Energía y expresión. Te gusta comunicar, brillar y despertar nuevas ideas.",
      "Oso":"Protección. Eres refugio para otros. Tu fuerza es tranquila."
    };

    // ✅ PREGUNTAS B2C (tus preguntas) + scoring
    // Cada respuesta suma puntos a varios animales (sin que sea obvio).
    const QUESTIONS = [
      {
        q:"1️⃣ ¿Qué te da más energía?",
        opts:[
          { t:"A. Estar con quienes amas", pts:{ "Perro":2,"Pingüino":2,"Oso":1,"Elefante":1 } },
          { t:"B. Explorar algo nuevo", pts:{ "Caballo":2,"Conejo":1,"Zorro":1,"Jaguar":1 } },
          { t:"C. Pensar y observar", pts:{ "Búho":2,"Gato":1,"Jirafa":1,"Venado":1 } },
          { t:"D. Liderar o actuar", pts:{ "León":2,"Jaguar":2,"Tiburón":1,"Toro":1 } }
        ]
      },
      {
        q:"2️⃣ Cuando enfrentas un reto…",
        opts:[
          { t:"A. Buscas apoyo", pts:{ "Perro":2,"Pingüino":2,"Oso":1,"Elefante":1 } },
          { t:"B. Analizas primero", pts:{ "Búho":2,"Gato":1,"Zorro":1,"Jirafa":1 } },
          { t:"C. Avanzas sin miedo", pts:{ "Tiburón":2,"Jaguar":2,"León":1,"Rinoceronte":1 } },
          { t:"D. Te adaptas con creatividad", pts:{ "Zorro":2,"Conejo":2,"Gallo":1,"Caballo":1 } }
        ]
      },
      {
        q:"3️⃣ ¿Cómo te describen tus amigos?",
        opts:[
          { t:"A. Protector/a", pts:{ "Oso":2,"Perro":1,"Elefante":1,"Rinoceronte":1 } },
          { t:"B. Independiente", pts:{ "Gato":2,"Búho":1,"Jirafa":1,"Venado":1 } },
          { t:"C. Alegre", pts:{ "Conejo":2,"Gallo":2,"Pingüino":1,"Zorro":1 } },
          { t:"D. Intenso/a", pts:{ "Jaguar":2,"Tiburón":1,"León":1,"Toro":1 } }
        ]
      },
      {
        q:"4️⃣ ¿Qué te inspira más?",
        opts:[
          { t:"A. La naturaleza", pts:{ "Venado":2,"Elefante":1,"Oso":1,"Jirafa":1 } },
          { t:"B. El movimiento", pts:{ "Caballo":2,"Conejo":1,"Jaguar":1,"Tiburón":1 } },
          { t:"C. El silencio", pts:{ "Búho":2,"Gato":1,"Elefante":1,"Venado":1 } },
          { t:"D. Los desafíos", pts:{ "León":2,"Toro":2,"Jaguar":1,"Rinoceronte":1 } }
        ]
      },
      {
        q:"5️⃣ ¿Qué tipo de energía sientes más tuya?",
        opts:[
          { t:"A. Calmado/a", pts:{ "Elefante":2,"Oso":2,"Venado":1,"Jirafa":1 } },
          { t:"B. Fuerte", pts:{ "Toro":2,"Rinoceronte":2,"Jaguar":1,"León":1 } },
          { t:"C. Curioso/a", pts:{ "Zorro":2,"Conejo":2,"Búho":1,"Gallo":1 } },
          { t:"D. Elegante", pts:{ "Gato":2,"Venado":2,"Jirafa":1,"Búho":1 } }
        ]
      },
      {
        q:"6️⃣ Si fueras un paisaje…",
        opts:[
          { t:"A. Bosque tranquilo", pts:{ "Venado":2,"Oso":2,"Elefante":1,"Búho":1 } },
          { t:"B. Montaña alta", pts:{ "Jirafa":2,"León":1,"Búho":1,"Toro":1 } },
          { t:"C. Océano profundo", pts:{ "Tiburón":2,"Jaguar":1,"Elefante":1,"Rinoceronte":1 } },
          { t:"D. Pradera abierta", pts:{ "Caballo":2,"Perro":1,"Conejo":1,"Pingüino":1 } }
        ]
      },
      {
        q:"7️⃣ ¿Qué buscas al crear algo con tus manos?",
        opts:[
          { t:"A. Conectar", pts:{ "Perro":2,"Pingüino":2,"Elefante":1,"Oso":1 } },
          { t:"B. Expresarte", pts:{ "Gallo":2,"Gato":1,"Zorro":1,"Venado":1 } },
          { t:"C. Relajarte", pts:{ "Búho":2,"Elefante":1,"Venado":1,"Oso":1 } },
          { t:"D. Superarte", pts:{ "León":2,"Toro":2,"Jaguar":1,"Tiburón":1 } }
        ]
      }
    ];

    const card = document.getElementById("zq-card");
    const actions = document.getElementById("zq-actions");
    const progress = document.getElementById("zq-progress");

    let idx = 0;
    const score = {};
    ANIMALS.forEach(a => score[a]=0);

    function emoji(a){
      const m = {
        "Perro":"🐕","Gato":"🐱","Caballo":"🐎","Búho":"🦉","Toro":"🐂","Zorro":"🦊","Rinoceronte":"🦏",
        "Elefante":"🐘","Jirafa":"🦒","Jaguar":"🐆","Venado":"🦌","Tiburón":"🦈","Pingüino":"🐧",
        "Conejo":"🐇","León":"🦁","Gallo":"🐓","Oso":"🐻"
      };
      return m[a] || "✨";
    }

    function topAnimal(){
      let best = ANIMALS[0], bestVal = -Infinity;
      ANIMALS.forEach(a => { if(score[a] > bestVal){ best=a; bestVal=score[a]; } });

      // desempate: si hay empate, elige aleatorio entre los top
      const top = ANIMALS.filter(a => score[a] === bestVal);
      if(top.length > 1) best = top[Math.floor(Math.random()*top.length)];
      return best;
    }

    function render(){
      progress.textContent = `Pregunta ${idx+1} de ${QUESTIONS.length}`;
      const Q = QUESTIONS[idx];

      card.innerHTML = `
        <h3 style="margin:0 0 10px;color:#111;font-size:18px;line-height:1.3;">${Q.q}</h3>
        <div class="zq-grid">
          ${Q.opts.map((o,i)=>`<button type="button" class="zq-btn" data-i="${i}">${o.t}</button>`).join("")}
        </div>
      `;

      actions.innerHTML = idx>0 ? `<button type="button" id="zq-back" class="zq-ghost">Atrás</button>` : ``;

      card.querySelectorAll("button[data-i]").forEach(btn=>{
        btn.addEventListener("click", ()=>{
          const opt = Q.opts[Number(btn.dataset.i)];
          Object.entries(opt.pts).forEach(([a,p])=>{ if(score[a] !== undefined) score[a]+=p; });
          idx++;
          if(idx < QUESTIONS.length) render();
          else showResult();
        });
      });

      const backBtn = document.getElementById("zq-back");
      if(backBtn){
        backBtn.addEventListener("click", ()=>{
          idx = 0; ANIMALS.forEach(a => score[a]=0);
          render();
        });
      }
    }

    function showResult(){
      progress.textContent = `Resultado listo`;
      const animal = topAnimal();

      const msg = encodeURIComponent(
        `Hola Zutopía, hice el test "¿Con qué animal me identifico?" y mi resultado fue: ${animal}. ` +
        `¿Me puedes mostrar opciones (rompecabezas 3D / magnético / escultura) y precios?`
      );
      const wa = `https://wa.me/573122860601?text=${msg}`;

      card.innerHTML = `
        <div style="text-align:center;">
          <div style="font-size:42px;line-height:1;">${emoji(animal)}</div>
          <h3 style="margin:8px 0 4px;color:#111;">Tu animal es: <span style="text-transform:uppercase;">${animal}</span></h3>
          <p style="margin:0;opacity:.9;color:#111;">${COPY[animal] || ""}</p>

          <div style="margin-top:14px;padding:12px;border-radius:12px;background:#f7f7f7;color:#111;text-align:left;">
            <strong>Tip Zutopía:</strong> este resultado puede convertirse en una pieza de arte armable para tu casa, un regalo especial o un recuerdo significativo. 
            También hacemos diseños totalmente personalizados basados en la foto de tu mascota o en el mensaje que quieras representar.
          </div>
        </div>
      `;

      actions.innerHTML = `
        <a href="${wa}" target="_blank" class="zq-linkbtn">Escríbenos por WhatsApp</a>
        <button type="button" id="zq-restart" class="zq-ghost">Repetir test</button>
      `;

      document.getElementById("zq-restart").addEventListener("click", ()=>{
        idx = 0; ANIMALS.forEach(a => score[a]=0);
        render();
      });
    }

    render();
  });
})();
